
import { useEffect, useRef, useState } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion'
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { ProgressBar } from 'primereact/progressbar';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { InputTextarea } from 'primereact/inputtextarea';
import { Api } from '../../services/api';
import { FinancialControllerTemplate } from '../../services/Template/financial-template';
import { useNavigate, useParams } from 'react-router-dom';
import { InputNumber } from 'primereact/inputnumber';
import { IoArrowBackSharp } from 'react-icons/io5';

const FinancialController = ({ typeOfData }) => {

    var isAdmin = localStorage.getItem('isAdmin');

    const navigate = useNavigate();

    const { viewUserId } = useParams();
    const { viewRoleId } = useParams();
    const [billableTime, setBillableTime] = useState([]);

    const [annualQuarters, setAnnualQuarters] = useState([]);

    const [backCharges, setBackCharges] = useState([]);

    const [isLoading, setIsLoading] = useState(true);



    const [totalPointMeetingJob, setTotalPointMeetingJob] = useState("");
    const [pointsMeetingJob, setPointsMeetingJob] = useState("");

    const [userName, setUserName] = useState("");
    const toast = useRef(null);
    ;


    const [primaryTask, setPrimaryTask] = useState(FinancialControllerTemplate.getFormName().primary_task);
    const [secondryTask, setSecondryTask] = useState(FinancialControllerTemplate.getFormName().secondry_task);
    const [anyAdditionalTopics, setAnyAdditionalTopics] = useState(FinancialControllerTemplate.getFormName().any_additional_topics);
    const [discussionItem, setDiscussionItem] = useState(FinancialControllerTemplate.getFormName().discussion_item);
    const [goalForTheWeek, setGoalForTheWeek] = useState(FinancialControllerTemplate.getFormName().goals_for_the_week);
    const [week, setWeek] = useState(FinancialControllerTemplate.getFormName().weeks[0].week);
    const [weeksList, setWeeksList] = useState(FinancialControllerTemplate.getFormName().weeks);
    const [annualDeliverables, setAnnualDeliverables] = useState(FinancialControllerTemplate.getFormName().annual_deliverbles);

    const [toDiscuss, setToDiscuss] = useState(FinancialControllerTemplate.getFormName().to_discuss);


    const [firstAccName, setFirstAccName] = useState('');

    const [checkAdmin, setCheckAdmin] = useState('');

    const formik = useFormik({
        initialValues: FinancialControllerTemplate.getFormName(),
        validate: (data) => {

        },

        onSubmit: (data) => {

            data.total_points_meeting_job = totalPointMeetingJob;
            data.points_meeting_job = pointsMeetingJob;

            // data.user_id = localStorage.getItem('user_id');
            // data.role_id = localStorage.getItem('role_id');
            data.typeOfData = typeOfData;

            var url = Api.API_BASE_URL + 'financial-controller/save';

            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });

                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });


        }
    });


    // TODO ------------------------ 

    const handleAddInputForAnnualDeliverables = (leng) => {

        var s = {
            title: '',
            description: '',
            lida_homes_core_value: '',
        };
        setAnnualDeliverables([...annualDeliverables, s]);
        formik.values.annual_deliverbles.push(s);




    };

    const handleDeleteInputForAnnualDeliverables = (index) => {
        formik.values.annual_deliverbles.splice(index, 1);
        setAnnualDeliverables([...annualDeliverables, FinancialControllerTemplate.getFormName().annual_deliverbles[0]]);
        var newArray = [...annualDeliverables];
        newArray.splice(index, 1);
        setAnnualDeliverables(newArray);
    };

    const handleAddInputForPrimaryTask = () => {
        var s = {
            title: '',
            due_date: '',
            completed: 'NO',
            comments: '',
        };
        setPrimaryTask([...primaryTask, s]);
        formik.values.primary_task.push(s);


    };

    const handleDeleteInputForPrimaryTask = (index) => {
        formik.values.primary_task.splice(index, 1);
        setPrimaryTask([...primaryTask, FinancialControllerTemplate.getFormName().primary_task[0]]);
        var newArray = [...primaryTask];
        newArray.splice(index, 1);
        setPrimaryTask(newArray);
    };


    const handleAddInputForSecondryTask = () => {
        var s = {
            title: '',
            due_date: '',
            completed: 'NO',
            comments: '',
        };
        setSecondryTask([...secondryTask, s]);
        formik.values.secondry_task.push(s);


    };

    const handleDeleteInputForSecondryTask = (index) => {
        formik.values.secondry_task.splice(index, 1);
        setSecondryTask([...secondryTask, FinancialControllerTemplate.getFormName().secondry_task[0]]);
        var newArray = [...secondryTask];
        newArray.splice(index, 1);
        setSecondryTask(newArray);
    };

    const handleAddInputForAnyAdditionalTopics = () => {
        var s = {
            title: '',
            comments: '',
        };
        setAnyAdditionalTopics([...anyAdditionalTopics, s]);
        formik.values.any_additional_topics.push(s);


    };

    const handleDeleteInputForAnyAdditionalTopics = (index) => {
        formik.values.any_additional_topics.splice(index, 1);
        setAnyAdditionalTopics([...anyAdditionalTopics, FinancialControllerTemplate.getFormName().any_additional_topics[0]]);
        var newArray = [...anyAdditionalTopics];
        newArray.splice(index, 1);
        setAnyAdditionalTopics(newArray);
    };

    const handleAddInputForDiscussionItem = () => {
        var s = {
            discussion_items: '',
        };
        setDiscussionItem([...discussionItem, s]);
        formik.values.discussion_item.push(s);


    };

    const handleDeleteInputForDiscussionItem = (index) => {
        formik.values.discussion_item.splice(index, 1);
        setDiscussionItem([...discussionItem, FinancialControllerTemplate.getFormName().discussion_item[0]]);
        var newArray = [...discussionItem];
        newArray.splice(index, 1);
        setDiscussionItem(newArray);
    };


    const handleAddInputForGoalForTheWeek = () => {
        var s = {
            title: '',
            reason_1: '',
            reason_2: '',
            comments_1: '',
            comments_2: '',
        };
        setGoalForTheWeek([...goalForTheWeek, s]);
        formik.values.goals_for_the_week.push(s);


    };

    const handleDeleteInputForGoalForTheWeek = (index) => {
        formik.values.goals_for_the_week.splice(index, 1);
        setGoalForTheWeek([...goalForTheWeek, FinancialControllerTemplate.getFormName().goals_for_the_week[0]]);
        var newArray = [...goalForTheWeek];
        newArray.splice(index, 1);
        setGoalForTheWeek(newArray);
    };

    const handleAddInputFortoDiscuss = () => {
        var s = {
            title: '',
            comments: '',
        };
        setToDiscuss([...toDiscuss, s]);
        formik.values.to_discuss.push(s);


    };

    const handleDeleteInputFortoDiscuss = (index) => {
        formik.values.to_discuss.splice(index, 1);
        setToDiscuss([...toDiscuss, FinancialControllerTemplate.getFormName().to_discuss[0]]);
        var newArray = [...toDiscuss];
        newArray.splice(index, 1);
        setToDiscuss(newArray);
    };

    const handleAddInputForWeek = (index) => {

        var s = {
            title: '',
            comments: '',
            point_1: '',
            point_2: '',
            vp_comments: '',
        };
        setWeek([...week, s]);
        formik.values.weeks[index].week.push(s);






    };

    const handleDeleteInputForWeek = (index, key) => {
        formik.values.weeks[key].week.splice(index, 1);
        setWeek([...week, FinancialControllerTemplate.getFormName().weeks[0].week]);
        var newArray = [...week];
        newArray.splice(index, 1);
        setWeek(newArray);
    };


    const handleAddForWeeksList = () => {
        var s = FinancialControllerTemplate.getFormName().weeks[0];
        setWeeksList([...weeksList, s]);
        formik.values.weeks.push(s);


    };

    const handleDeleteInputForWeeksList = (index) => {
        formik.values.weeks.splice(index, 1);
        setWeeksList([...weeksList, FinancialControllerTemplate.getFormName().weeks[0]]);
        var newArray = [...weeksList];
        newArray.splice(index, 1);
        setWeeksList(newArray);
    };


    //! -----------------------
    const headerStyle = {
        background: "#FEC025",
        border: "1px solid #E9ECEF",
        textAlign: "center",
        fontSize: "14px",
    };

    const cellStyle = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "center",
        fontSize: "14px",
        border: '1px solid white',
        padding: '1px',
    };


    const cellStylea = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "start",
        fontSize: "14px",
        padding: "5px",
        border: '1px solid white',

    };
    const cellStyleH = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "center",
        fontSize: "14px",
        border: '1px solid white',
        height: '50px'
    };

    const cellStyleW = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: 'white',
        paddingTop: '5px',
        fontSize: "14px",

    };

    const cellStyleD = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: '#9999',
        fontSize: "14px",

    };

    const yesCellStyle = {
        ...cellStyle,
    };

    const dropdownCellStyle = {
        ...yesCellStyle,
        padding: "0",
    };

    //! ----------------------------------------------------------

    useEffect(() => {


        var name = localStorage.getItem('name');

        setIsLoading(false);
        if (viewRoleId == undefined || viewUserId == undefined) {
            var user_id = localStorage.getItem('user_id');
            var role_id = localStorage.getItem('role_id');
            setUserName(name);
            fetchData(user_id, role_id);
        } else {
            fetchData(viewUserId, viewRoleId);
        }

        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, []);



    const fetchData = (user_id, role_id) => {

        var _body = {
            userId: user_id,
            role_id: role_id,

        }

        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        formik.setFieldValue(`role_id`, role_id);
        formik.setFieldValue(`user_id`, user_id);

        fetch(Api.API_BASE_URL + 'financial-controller/get', {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {

                setUserName(response.name);

                setTotalPointMeetingJob(response.total_points_meeting_job);
                setPointsMeetingJob(response.points_meeting_job);

                if (response.error == '') {

                    if (response.annualquarters) {

                        setAnnualQuarters(response.annualquarters);

                        formik.setFieldValue('q1', response.annualquarters[0].ltTeam);
                        formik.setFieldValue('q2', response.annualquarters[1].ltTeam);
                        formik.setFieldValue('q3', response.annualquarters[2].ltTeam);
                        formik.setFieldValue('q4', response.annualquarters[3].ltTeam);

                        formik.setFieldValue('vpCommentsq1', response.annualquarters[0].vpComments);
                        formik.setFieldValue('vpCommentsq2', response.annualquarters[1].vpComments);
                        formik.setFieldValue('vpCommentsq3', response.annualquarters[2].vpComments);
                        formik.setFieldValue('vpCommentsq4', response.annualquarters[3].vpComments);

                        formik.setFieldValue('coreValuesq1', response.annualquarters[0].coreValues);
                        formik.setFieldValue('coreValuesq2', response.annualquarters[1].coreValues);
                        formik.setFieldValue('coreValuesq3', response.annualquarters[2].coreValues);
                        formik.setFieldValue('coreValuesq4', response.annualquarters[3].coreValues);

                    }

                    if (response.backCharges) {
                        setBackCharges(response.backCharges);
                    }                    

                    setBillableTime(response.billableTime);

                    if (response.annual_deliverbles.length > 0) {
                        formik.setFieldValue(`annual_deliverbles`, response.annual_deliverbles);
                        setAnnualDeliverables(response.annual_deliverbles);
                    }

                    if (response.primary_task.length > 0) {
                        formik.setFieldValue(`primary_task`, response.primary_task);
                        setPrimaryTask(response.primary_task);
                    }
                    if (response.secondry_task.length > 0) {
                        formik.setFieldValue(`secondry_task`, response.secondry_task);
                        setSecondryTask(response.secondry_task);
                    }
                    if (response.any_additional_topics.length > 0) {
                        formik.setFieldValue(`any_additional_topics`, response.any_additional_topics);
                        setAnyAdditionalTopics(response.any_additional_topics);
                    }
                    if (response.any_additional_topics.length > 0) {
                        formik.setFieldValue(`any_additional_topics`, response.any_additional_topics);
                        setAnyAdditionalTopics(response.any_additional_topics);
                    }
                    if (response.goals_for_the_week.length > 0) {
                        formik.setFieldValue(`goals_for_the_week`, response.goals_for_the_week);
                        setGoalForTheWeek(response.goals_for_the_week);
                    }
                    if (response.to_discuss.length > 0) {
                        formik.setFieldValue(`to_discuss`, response.to_discuss);
                        setToDiscuss(response.to_discuss);
                    }
                    if (response.discussion_item.length > 0) {
                        formik.setFieldValue(`discussion_item`, response.discussion_item);
                        setDiscussionItem(response.discussion_item);
                    }

                    if (response.weeks.length > 0) {
                        formik.setFieldValue(`weeks`, response.weeks);
                        setWeeksList(response.weeks);


                    }
                    if (response.annualquarters) {

                        setAnnualQuarters(response.annualquarters);

                    }

                    if (response.backCharges) {
                        // formik.setFieldValue('backCharges', response.backCharges);
                        setBackCharges(response.backCharges);
                    }

                    if (response.acounting_administraction) {
                        let timestamp = new Date(response.acounting_administraction.date);

                        if (!isNaN(timestamp.getTime())) {
                            let formData = timestamp.toISOString().split('T')[0];

                            console.log('formData-----', formData)
                            formik.setFieldValue(`date`, formData);
                        }
                        formik.setFieldValue(`name`, response.acounting_administraction.name);

                        formik.setFieldValue(`month`, response.acounting_administraction.month);
                        formik.setFieldValue(`year_goal`, response.acounting_administraction.year_goal);
                        formik.setFieldValue(`check_in_how_are_you_doing`, response.acounting_administraction.check_in_how_are_you_doing);
                        formik.setFieldValue(`what_can_i_do_support_you`, response.acounting_administraction.what_can_i_do_support_you);

                        formik.setFieldValue(`vp_comment_1`, response.acounting_administraction.vp_comment_1);
                        formik.setFieldValue(`vp_comment_2`, response.acounting_administraction.vp_comment_2);
                        formik.setFieldValue(`vp_comment_3`, response.acounting_administraction.vp_comment_3);
                        formik.setFieldValue(`vp_comment_4`, response.acounting_administraction.vp_comment_4);



                    }

                    setIsLoading(false);

                } else {
                    if (response.annualquarters) {

                        setAnnualQuarters(response.annualquarters);


                        formik.setFieldValue('q1', response.annualquarters[0].ltTeam);
                        formik.setFieldValue('q2', response.annualquarters[1].ltTeam);
                        formik.setFieldValue('q3', response.annualquarters[2].ltTeam);
                        formik.setFieldValue('q4', response.annualquarters[3].ltTeam);

                        formik.setFieldValue('vpCommentsq1', response.annualquarters[0].vpComments);
                        formik.setFieldValue('vpCommentsq2', response.annualquarters[1].vpComments);
                        formik.setFieldValue('vpCommentsq3', response.annualquarters[2].vpComments);
                        formik.setFieldValue('vpCommentsq4', response.annualquarters[3].vpComments);

                        formik.setFieldValue('coreValuesq1', response.annualquarters[0].coreValues);
                        formik.setFieldValue('coreValuesq2', response.annualquarters[1].coreValues);
                        formik.setFieldValue('coreValuesq3', response.annualquarters[2].coreValues);
                        formik.setFieldValue('coreValuesq4', response.annualquarters[3].coreValues);


                    }

                    if (response.backCharges) {

                        setBackCharges(response.backCharges);

                    }

                    setBillableTime(response.billableTime);
                    setIsLoading(false);
                }

            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
            });

    }


    const priceBodyTemplatee = (rowData) => {
        if (rowData === '') {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {

            return '';
        }

        const isNegative = rowData < 0; // Check if the value is negative

        return (
            <span style={{ color: isNegative ? "red" : "black" }}>
                {formatCurrency(rowData)}
                {/* $ {numberValue.toFixed(2) } */}
            </span>
        );
    };

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };
    // --------------------------------------------------------------------
    const renderTextArea = (fieldName, placeholder, formData = '') => (
        <textarea
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            value={formData != '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
        ></textarea>
    );

    const renderTextAreaFull = (fieldName, placeholder, formData = '', rowSpan = 2, backgroundColor = 'white',) => (
        <InputTextarea
            placeholder={placeholder}
            name={fieldName}
            autoResize
            rows={rowSpan}
            id={fieldName}
            value={formData !== '' ? formData : formik.values[fieldName]}

            onChange={(e) => {
                console.log(e.target.value)
                // setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value)
            }}
            className='px-2'
            style={{
                width: '100%',
                boxSizing: 'border-box',
                border: 'none',
                outline: 'none',
                color: '#495057',
                display: 'flex',
                alignItems: 'center',
                paddingTop: '8px',
                backgroundColor: backgroundColor
            }}
        ></InputTextarea>
    );

    const renderInputAreaForAmount = (fieldName, formData = '') => {
        var roleId = localStorage.getItem('role_id')

        return (
            <InputNumber
                inputId="currency-us"
                className="text-center"
                inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
                placeholder="$0.00"
                value={formData != '' ? formData : formik.values[fieldName]}
                onChange={(e) => {
                    formik.setFieldValue(fieldName, e.value)
                }
                }
                // readOnly={roleId == 2 || roleId == 12 || roleId == 13 || roleId == 1 ? false : true}
                readOnly={isAdmin === 'Y' ? false : true}
                mode="currency"
                currency="USD"
                locale="en-US"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                    }
                }}
                style={{
                    width: "100%",
                    height: "40px",
                    boxSizing: "border-box",
                    border: "none",
                    fontSize: "18px",
                    textAlign: "center !important",
                    marginTop: "0px",
                    outline: 'none',
                }}
            />
        )
    };

    const priceBodyTemplateeYearly = (rowData) => {
        if (rowData === '') {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {

            return '';
        }

        const isNegative = rowData < 0; // Check if the value is negative

        return (
            <span style={{ color: isNegative ? "red" : "black", }}>
                {formatCurrency(rowData)}
            </span>
        );
    };

    const renderInputArea = (fieldName, placeholder, type = 'text', formdata = '', color = 'white') => (
        <input
            type={type}
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            value={formdata != '' ? formdata : formik.values[fieldName]}
            onChange={(e) => { formik.setFieldValue(fieldName, e.target.value) }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent form submission on Enter key press
                }
            }}
            style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px',  textAlign: 'center', marginTop: '0px', backgroundColor: color }}
            onFocus={(e) => {
                e.target.style.setProperty('background-color', color, 'important');
            }}
            onBlur={(e) => {
                e.target.style.setProperty('background-color', color, 'important');
            }}
            autoComplete="off"
        />
    );

    const renderInputAreaY = (fieldName, placeholder, type = 'text', formdata = '', color = '#FEC025') => (
        <input
            type={type}
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            value={formdata != '' ? formdata : formik.values[fieldName]}
            onChange={(e) => { formik.setFieldValue(fieldName, e.target.value) }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent form submission on Enter key press
                }
            }}
            style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px',  textAlign: 'center', marginTop: '0px', backgroundColor: color }}
            onFocus={(e) => {
                e.target.style.setProperty('background-color', color, 'important');
            }}
            onBlur={(e) => {
                e.target.style.setProperty('background-color', color, 'important');
            }}
            autoComplete="off"
        />
    );

    const renderSelect1 = (fieldName, formData = '') => {

        var val = (formData != '') ? formData : formik.values[fieldName];


        return <select
            name={fieldName}
            id={fieldName}
            value={(formData != '') ? formData : formik.values[fieldName]}
            className={'select-text-color-' + val}
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', textAlign: 'center',  color: 'white', backgroundColor: '#ff0000', border: 'none' }}>
            <option value="NO">NO</option>
            <option value="YES">YES</option>
        </select>
    };

    const totalClientEmailWeek = (filedName, weekIndex) => {
        var sum = 0;
        formik.values.weeks[weekIndex].week.forEach((element, index) => {
            if (element[filedName]) {
                if (index == 0) { } else {
                    sum += parseFloat(element[filedName]);
                }
                // sum += parseFloat(element[filedName]);
            }

        });

        return (
            <span>
                {sum}
            </span>
        )
    }



    const cilentPlayBookTotalPerColor = (filedName, weekIndex, totalWeek) => {
        var sum = 0;
        formik.values.weeks[weekIndex].week.forEach((element, index) => {
            if (element[filedName]) {
                if (index == 0) { } else {
                    sum += parseFloat(element[filedName]);
                }

                // sum += parseFloat(element[filedName]);

            }

        });
        var per = 0;
        if (totalWeek != 0) {
            per = ((sum / totalWeek) * 100)
        }


        var color = "#22A33D"
        if (per < 90) {
            color = "#FFBF00"
        }
        if (per < 80) {
            color = "red"
        }

        if (per < 70) {
            color = "red"
        }


        return (

            <ProgressBar value={per.toFixed(0)} color={color} ></ProgressBar>

        )
    }





    return (
        <>
            <Toast ref={toast} />
            <form onSubmit={formik.handleSubmit} >
                {typeOfData != 'view' ? (<div className="flex d-flex justify-content-end top-button submitbutton ">

                    <Button title='Save' className="m-2  p-2  d-flex align-items-center customSave-button" type="submit">
                        <strong className="mr-2 ">Save</strong>
                        <i className="pi pi-save"></i>
                    </Button>


                </div>) : 'Y' == isAdmin ? (<div className="flex d-flex justify-content-between top-button submitbutton ">

                    <button type='button' onClick={() => { navigate(-1); window.close(); }} className='customSave-button m-2 flex'>
                        <IoArrowBackSharp className='text-sm' />
                        <span>Back</span>
                    </button>

                    <Button title='Save' className="m-2  p-2  d-flex align-items-center customSave-button" type="submit">
                        <strong className="mr-2 ">Save</strong>
                        <i className="pi pi-save"></i>
                    </Button>


                </div>) : (<div></div>)}
                <div className="cardd accordian-header" style={{ border: 'none', minHeight: '82vh', margin: 0, padding: 10 }} >

                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (

                        <Accordion multiple activeIndex={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9]}>

                            <AccordionTab header={
                                typeOfData === 'accounting'
                                    ? 'ACCOUNTING ADMINISTRATOR PLAYBOOK'
                                    : typeOfData === 'financial'
                                        ? 'FINANCIAL ADMINISTRATOR PLAYBOOK'
                                        : ''
                            } className='mt-2 '>
                                {/* <AccordionTab header="ACCOUNTING ADMINISTRATOR PLAYBOOK" className='mt-2 '> */}

                                <div className="table-container form-bg" style={{ overflowX: "auto", }}>
                                    {/* <div className="table-container form-bg" style={{ overflowX: "auto",paddingBottom:'10px' }}> */}
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, }} colSpan={3} >
                                                    ACCOUNTING ADMINISTRATOR PLAYBOOK
                                                </th>
                                            </tr>

                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td style={{ ...cellStylea, height: "24px", }} colSpan={3}>
                                                    Client Email Playbook Update sent out on Friday after the 15th & 30th of every month.  Standard Email Client Update sent out every other Friday
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ ...cellStylea, minWidth: "105px", height: "24px", paddingTop: '10px', paddingBottom: '10px', }}>
                                                    Name:
                                                </td>

                                                <td style={{ ...cellStylea, minWidth: "125px", height: "24px", paddingTop: '10px', paddingBottom: '10px', }}>
                                                    {<strong style={{ marginLeft: '65px', marginRight: '-45px' }}>{userName}</strong>}
                                                </td>

                                                <td style={{ ...cellStyle, minWidth: "250px", }}>
                                                    <div style={{ display: 'flex', width: '100%', gap: '12px' }}>

                                                        <td style={{ ...cellStyle, flex: 1, minWidth: "125px", textAlign: 'center', border: 'none' }}>
                                                            Month
                                                        </td>

                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStylea, minWidth: "125px", }}>
                                                    Date:
                                                </td>

                                                <td style={{ minWidth: "150px", }}>
                                                    <div style={{ display: 'flex', width: '100%', gap: '12px', padding: 0 }}>

                                                        <div style={{ ...cellStyleD, flex: 1, }}>
                                                            <input
                                                                type="date"
                                                                id="name"
                                                                value={formik.values.date}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue("date", e.target.value)

                                                                }}
                                                                style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px', fontSize: '17px', textAlign: 'center', marginTop: '0px', backgroundColor: '#9999' }}
                                                            />
                                                        </div>

                                                    </div>
                                                </td>
                                                <td style={{ minWidth: "150px", }}>
                                                    <div style={{ display: 'flex', height: 40, width: '100%', gap: '12px', padding: 0, }}>

                                                        <div style={{ ...cellStyleD, flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                            <div style={{ fontWeight: 'bolder' }}>
                                                                {formik.values.month != '' ? formik.values.month : new Date().toLocaleString('default', { month: 'long' })}
                                                            </div>

                                                        </div>

                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: '300px', }}>
                                                Quarter
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                LT Team  {new Date().getFullYear()}  Rock
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                Projections & Actuals
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                Yearly/Quarterly Variance
                                                </th>
                                                <th style={{ ...headerStyle, width: '250px', }}>
                                                Vp Construction Ops Comments Only
                                                </th>
                                                {/* <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Core Values
                                                </th> */}

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                annualQuarters.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{item.Quarter}</td>

                                                            {/* <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{priceBodyTemplatee(item.ltTeam)}</td> */}

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    index == 0 ? renderInputAreaForAmount(`q1`, formik.values.q1) : index == 1 ? renderInputAreaForAmount(`q2`, formik.values.q2) : index == 2 ? renderInputAreaForAmount(`q3`, formik.values.q3) : index == 3 ? renderInputAreaForAmount(`q4`, formik.values.q4) : priceBodyTemplatee(formik.values.q1 + formik.values.q2 + formik.values.q3 + formik.values.q4)

                                                                }</td>

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{priceBodyTemplatee(item.projection)}</td>

                                                            {/* <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{priceBodyTemplatee(item.yearly)}</td> */}

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    index == 0 ? priceBodyTemplateeYearly(item.projection - formik.values.q1) : index == 1 ? priceBodyTemplateeYearly(item.projection - formik.values.q2) : index == 2 ? priceBodyTemplateeYearly(item.projection - formik.values.q3) : index == 3 ? priceBodyTemplateeYearly(item.projection - formik.values.q4) : priceBodyTemplateeYearly(item.projection - (formik.values.q1 + formik.values.q2 + formik.values.q3 + formik.values.q4))

                                                                }</td>

                                                            {/* <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>{item.vpComments}</td> */}

                                                            <td style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    index == 0 ? renderTextAreaFull(`vpCommentsq1`, '', formik.values.vpCommentsq1) :
                                                                        index == 1 ? renderTextAreaFull(`vpCommentsq2`, '', formik.values.vpCommentsq2) :
                                                                            index == 2 ? renderTextAreaFull(`vpCommentsq3`, '', formik.values.vpCommentsq3) :
                                                                                index == 3 ? renderTextAreaFull(`vpCommentsq4`, '', formik.values.vpCommentsq4) :
                                                                                    (<div className='p-4'></div>)
                                                                }
                                                            </td>

                                                            {/* <td className='px-2' style={item.Quarter == 'Year' ? headerStyle : cellStyleH}>
                                                                {
                                                                    index == 0 ? renderTextAreaFull(`coreValuesq1`, '', formik.values.coreValuesq1, '', "") :
                                                                        index == 1 ? renderTextAreaFull(`coreValuesq2`, '', formik.values.coreValuesq2, '', "") :
                                                                            index == 2 ? renderTextAreaFull(`coreValuesq3`, '', formik.values.coreValuesq3, '', "") :
                                                                                index == 3 ? renderTextAreaFull(`coreValuesq4`, '', formik.values.coreValuesq4, '', "") :
                                                                                    (<div className='p-4'></div>)
                                                                }
                                                            </td> */}

                                                        
                                                        </tr>
                                                    )
                                                })
                                            }

                                        </tbody>
                                    </table>
                                </div>


                            </AccordionTab>

                            {/* Back Charges Section */}
                            {/* Back Charge section are after Fees and Reimbursables */}
                            <AccordionTab header="BACK CHARGES" className="mt-2" >
                                <div className="table-container" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "200px" }}>
                                                    Playbook
                                                </th>
                                                <th style={{ ...headerStyle, width: "120px" }}>
                                                    Date Created
                                                </th>
                                                <th style={{ ...headerStyle, width: "150px" }}>
                                                    Trade Name
                                                </th>
                                                <th style={{ ...headerStyle, width: "120px" }}>
                                                    Charge Amount
                                                </th>
                                                <th style={{ ...headerStyle, width: "200px" }}>
                                                    Comments
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Status
                                                    <div style={{ marginTop: "5px" }}>
                                                        <select 
                                                            defaultValue="all"
                                                            onChange={(e) => {
                                                                const filterValue = e.target.value;
                                                                const token = localStorage.getItem('authToken');
                                                                const headers = {
                                                                    'Content-Type': 'application/json',
                                                                    'Authorization': token ? `Bearer ${token}` : ''
                                                                };
                                                                
                                                                fetch(Api.API_BASE_URL + 'financial-controller/get', {
                                                                    method: "POST",
                                                                    headers: headers,
                                                                    body: JSON.stringify({
                                                                        userId: viewUserId || localStorage.getItem('user_id'),
                                                                        role_id: viewRoleId || localStorage.getItem('role_id')
                                                                    }),
                                                                })
                                                                .then(response => response.json())
                                                                .then(data => {
                                                                    if (data.backCharges) {
                                                                        const allCharges = data.backCharges;
                                                                        if (filterValue === 'all') {                                                                                                                   
                                                                            setBackCharges(allCharges);
                                                                        } else {
                                                                            const filteredCharges = allCharges.filter(charge => 
                                                                                filterValue === 'paid' ? charge.status === 'Y' : charge.status === 'N'
                                                                            );
                                                                            setBackCharges(filteredCharges);
                                                                        }
                                                                    }
                                                                })
                                                                .catch(error => console.error("Error:", error));
                                                            }}
                                                            style={{
                                                                padding: "2px",
                                                                borderRadius: "4px",
                                                                border: "1px solid #ccc",
                                                                fontSize: "12px",
                                                                width: "80px"
                                                            }}
                                                        >
                                                            <option value="all">All</option>
                                                            <option value="paid">Paid</option>
                                                            <option value="unpaid">Unpaid</option>
                                                        </select>
                                                    </div>
                                                </th>
                                                <th style={{ ...headerStyle, width: "120px" }}>
                                                    Timestamp
                                                </th>                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {backCharges.map((charge, index) => (
                                                <tr key={index}>
                                                    <td style={{ ...cellStyle, width: "200px" }}>
                                                        {charge.projectName || ''}
                                                    </td>
                                                    <td style={{ ...cellStyle, width: "120px" }}>
                                                        {charge.date ? new Date(charge.date).toISOString().split('T')[0] : ''}
                                                    </td>
                                                    <td style={{ ...cellStyle, width: "150px" }}>
                                                        {charge.tradeName || ''}
                                                    </td>
                                                    <td style={{ ...cellStyle, width: "120px" }}>
                                                        {charge.amount ? new Intl.NumberFormat('en-US', {
                                                            style: 'currency',
                                                            currency: 'USD'
                                                        }).format(charge.amount) : ''}
                                                    </td>
                                                    <td style={{ ...cellStyle, width: "200px" }}>
                                                        <InputTextarea
                                                            value={charge.comments || ''}
                                                            onChange={(e) => {
                                                                const updatedCharges = backCharges.map((c) =>
                                                                    c === charge ? { ...c, comments: e.target.value } : c
                                                                );
                                                                setBackCharges(updatedCharges);

                                                                const token = localStorage.getItem('authToken');
                                                                const headers = {
                                                                    'Content-Type': 'application/json',
                                                                    'Authorization': token ? `Bearer ${token}` : ''
                                                                };

                                                                fetch(Api.API_BASE_URL + 'financial-controller/update-charge-status', {
                                                                    method: 'POST',
                                                                    headers: headers,
                                                                    body: JSON.stringify({
                                                                        chargeId: charge._id,
                                                                        status: charge.status,
                                                                        comments: e.target.value
                                                                    })
                                                                })
                                                                .catch(error => {
                                                                    console.error('Error:', error);
                                                                });
                                                            }}
                                                            rows={2}
                                                            style={{ width: '100%', fontSize: '14px' }}
                                                        />
                                                    </td>
                                                    <td style={{ ...cellStyle, width: "100px" }}>
                                                        <div className="flex align-items-center justify-content-center">
                                                            <input
                                                                type="checkbox"
                                                                checked={charge.status === 'Y'}
                                                                onChange={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();

                                                                    const newStatus = e.target.checked ? 'Y' : 'N';

                                                                    const token = localStorage.getItem('authToken');
                                                                    const headers = {
                                                                        'Content-Type': 'application/json',
                                                                        'Authorization': token ? `Bearer ${token}` : ''
                                                                    };

                                                                    fetch(Api.API_BASE_URL + 'financial-controller/update-charge-status', {
                                                                        method: 'POST',
                                                                        headers: headers,
                                                                        body: JSON.stringify({
                                                                            chargeId: charge._id,
                                                                            status: newStatus,
                                                                            comments: charge.comments
                                                                        })
                                                                    })
                                                                        .then(response => response.json())
                                                                        .then(data => {
                                                                            if (data.error) {
                                                                                toast.current.show({
                                                                                    severity: 'error',
                                                                                    summary: 'Error',
                                                                                    detail: data.error
                                                                                });
                                                                            } else {
                                                                                const updatedCharges = backCharges.map((c, i) =>
                                                                                    c === charge ? { ...c, status: newStatus } : c
                                                                                );
                                                                                setBackCharges(updatedCharges);

                                                                                toast.current.show({
                                                                                    severity: 'success',
                                                                                    summary: 'Success',
                                                                                    detail: 'Status updated successfully'
                                                                                });
                                                                            }
                                                                        })
                                                                        .catch(error => {
                                                                            console.error('Error:', error);
                                                                            toast.current.show({
                                                                                severity: 'error',
                                                                                summary: 'Error',
                                                                                detail: 'Failed to update status'
                                                                            });
                                                                        });
                                                                }}
                                                                style={{
                                                                    width: '20px',
                                                                    height: '20px',
                                                                    cursor: 'pointer'
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td style={{ ...cellStyle, width: "150px" }}>
                                                        {charge.date_paid ? charge.date_paid.toString().split('T')[0] : ''}
                                                    </td>                                                    
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="ANNUAL DELIVERABLES" className='mt-2 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#FEC025' }}>
                                                <th style={{ ...headerStyle, width: "300px" }}>
                                                    Annual Deliverables:
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: 'auto', }}>
                                                    {/* GOAL <div>{renderInputArea()}</div> TOTAL <div>{renderInputArea()}</div> */}
                                                </th>
                                                <th style={{ ...headerStyle, width: '350px', }}>
                                                    Core Values
                                                </th>
                                                <th style={{ ...headerStyle, width: '100px', }}>
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {annualDeliverables.map((item, index) => (
                                                <tr>


                                                    <td style={cellStyle}>  {renderTextAreaFull(`annual_deliverbles.${index}.title`, '', formik.values.annual_deliverbles[index].title)}  </td>
                                                    <td style={cellStyle}>  {renderTextAreaFull(`annual_deliverbles.${index}.description`, '', formik.values.annual_deliverbles[index].description)}  </td>
                                                    <td style={cellStyle}>  {renderTextAreaFull(`annual_deliverbles.${index}.lida_homes_core_value`, '', formik.values.annual_deliverbles[index].lida_homes_core_value)}  </td>



                                                    <td style={cellStylea}>
                                                        {annualDeliverables.length != 1 ? (<FaTrash onClick={() => handleDeleteInputForAnnualDeliverables(index)} className='delete-buttonXX' />) : null}

                                                        {annualDeliverables.length - 1 == index ? (<FaPlus onClick={() => handleAddInputForAnnualDeliverables(annualDeliverables.length)} className='add-buttonXX' />) : null}
                                                    </td>

                                                </tr>
                                            ))}



                                        </tbody>
                                    </table>

                                </div>


                                <div className="table-container form-bg pt-4" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...cellStyle, width: "150px" }}>
                                                    Check in:  How are you doing?
                                                </th>
                                                <th style={{ ...cellStyle, width: '50px', }}>
                                                    {renderTextAreaFull(`check_in_how_are_you_doing`, '', formik.values.check_in_how_are_you_doing)}
                                                </th>
                                            </tr>

                                            <tr>
                                                <th style={{ ...cellStyle, width: "150px" }}>
                                                    What can I do to support you?
                                                </th>
                                                <th style={{ ...cellStyle, width: '250px', }}>
                                                    {renderTextAreaFull(`what_can_i_do_support_you`, '', formik.values.what_can_i_do_support_you)}
                                                </th>


                                            </tr>
                                        </thead>

                                    </table>

                                </div>

                            </AccordionTab>

                            {/* <AccordionTab header="PAYROLL" className='mt-2 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", width: "auto" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "300px" }} >
                                                    Payroll Date:
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "200px" }} >
                                                    From:
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    
                                                    {billableTime.length > 0 ? billableTime[0].payPeriodStartDate : ''}
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    To:
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    
                                                    {billableTime.length > 0 ? billableTime[0].payPeriodEndDate : ''}
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} colSpan={9}>
                                                     Labour Billable VS Unbillable Profit/Loss
                                                </th>

                                            </tr>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "" }}>
                                                    Division
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "" }} >
                                                    Name
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "" }} >
                                                    Billable Rate
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "" }} >
                                                    Billable Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "" }} >
                                                    Unbillable Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "180px" }} >
                                                    Vacation/Stat Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    EOS Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    Sales Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    Sick Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    Total Hours
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    % Unbillable Time
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    Loss vs Billable
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "150px" }} >
                                                    Loss vs LB
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "650px" }} >
                                                    VP CONSTRUCTION OPS COMMENTS
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {billableTime.length != 0 ? billableTime.map((billableTime, index) => {
                                                return (
                                                    <tr>
                                                        <td style={cellStylea}>{billableTime.division}</td>
                                                        <td style={cellStylea}>{billableTime.name}</td>
                                                        <td style={cellStyle}>${billableTime.billableRate}</td>
                                                        <td style={cellStyle}> {billableTime.billableTime} </td>
                                                        <td style={cellStyle}> {billableTime.unBillableTime} </td>
                                                        <td style={cellStyle}> {billableTime.vacatiomStatTime} </td>
                                                        <td style={cellStyle}> {billableTime.eosTime}</td>
                                                        <td style={cellStyle}> {billableTime.salesTime} </td>
                                                        <td style={cellStyle}>{billableTime.sickTime} </td>
                                                        <td style={cellStyle}> {billableTime.totalHours} </td>
                                                        <td style={cellStyle}>{billableTime.vacatiomStatTime}</td>
                                                        <td style={cellStyle}>$0.00</td>
                                                        <td style={cellStyle}>$0.00</td>
                                                        <td style={cellStyleW}>
                                                            <textarea
                                                                placeholder=""
                                                                style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none' }}
                                                            >
                                                            </textarea>
                                                        </td>
                                                    </tr>
                                                )



                                            }) : (

                                                <tr>
                                                    <td style={cellStyle}></td>
                                                    <td style={cellStyle}>{userName}</td>
                                                    <td style={cellStyle}>$0</td>
                                                    <td style={cellStyle}>0 </td>
                                                    <td style={cellStyle}> 0 </td>
                                                    <td style={cellStyle}> 0 </td>
                                                    <td style={cellStyle}> 0</td>
                                                    <td style={cellStyle}> 0 </td>
                                                    <td style={cellStyle}>0 </td>
                                                    <td style={cellStyle}> 0</td>
                                                    <td style={cellStyle}>0</td>
                                                    <td style={cellStyle}>$0.00</td>
                                                    <td style={cellStyle}>$0.00</td>
                                                    <td style={cellStyleW}>
                                                        <textarea
                                                            placeholder=""
                                                            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none' }}
                                                        >
                                                        </textarea>
                                                    </td>
                                                </tr>

                                            )}






                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab> */}

                            <AccordionTab header="PRIMARY TASKS" className='mt-2 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>

                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: '600px', textAlign: 'start' }}>
                                                    Primar Tasks:
                                                </th> <th style={{ ...headerStyle, width: '250px', }}>
                                                    Due Date:
                                                </th>
                                                <th style={{ ...headerStyle, width: '85px', }}>
                                                    Completed Yes/No
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: 'auto', }}>
                                                    Comments:
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Action
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {primaryTask.map((item, index) => (
                                                <tr>
                                                    <td style={{ ...cellStyleW, }}>{renderTextAreaFull(`primary_task.${index}.title`, '', formik.values.primary_task[index].title)}
                                                    </td>
                                                    <td style={{ ...cellStyleW, }}>{renderInputArea(`primary_task.${index}.due_date`, '', 'date', formik.values.primary_task[index].due_date)}
                                                    </td>
                                                    <td style={{ ...dropdownCellStyle, width: '85px', height: '32px', }}>{renderSelect1(`primary_task.${index}.completed`, formik.values.primary_task[index].completed)} </td>


                                                    <td style={{ ...cellStyleW, }}>{renderTextAreaFull(`primary_task.${index}.comments`, '', formik.values.primary_task[index].comments)}
                                                    </td>

                                                    <td style={cellStylea}>
                                                        {primaryTask.length != 1 ? (<FaTrash onClick={() => handleDeleteInputForPrimaryTask(index)} className='delete-buttonXX' />) : null}

                                                        {primaryTask.length - 1 == index ? (<FaPlus onClick={() => handleAddInputForPrimaryTask()} className='add-buttonXX' />) : null}
                                                    </td>

                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="SECONDARY TASKS" className='mt-2 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>

                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: '600px', textAlign: 'start' }}>
                                                    Secondary Tasks:
                                                </th> <th style={{ ...headerStyle, width: '250px', }}>
                                                    Due Date:
                                                </th>
                                                <th style={{ ...headerStyle, width: '85px', }}>
                                                    Completed Yes/No
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: 'auto', }}>
                                                    Comments:
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Action
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {secondryTask.map((item, index) => (
                                                <tr>
                                                    <td style={{ ...cellStyleW, }}>{renderTextAreaFull(`secondry_task.${index}.title`, '', formik.values.secondry_task[index].title)}
                                                    </td>
                                                    <td style={{ ...cellStyleW, }}>{renderInputArea(`secondry_task.${index}.due_date`, '', 'date', formik.values.secondry_task[index].due_date)}
                                                    </td>

                                                    <td style={{ ...dropdownCellStyle, width: '85px', height: '32px', }}>{renderSelect1(`secondry_task.${index}.completed`, formik.values.secondry_task[index].completed)} </td>

                                                    <td style={{ ...cellStyleW, }}>{renderTextAreaFull(`secondry_task.${index}.comments`, '', formik.values.secondry_task[index].comments)}
                                                    </td>

                                                    <td style={cellStylea}>
                                                        {secondryTask.length != 1 ? (<FaTrash onClick={() => handleDeleteInputForSecondryTask(index)} className='delete-buttonXX' />) : null}

                                                        {secondryTask.length - 1 == index ? (<FaPlus onClick={() => handleAddInputForSecondryTask()} className='add-buttonXX' />) : null}
                                                    </td>

                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="ANY ADDITIONAL TOPICS/INITIATIVES FOR DISCUSSION" className='mt-2 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>

                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: '600px', textAlign: 'start' }}>                                                    
                                                    Any additional topics/initiatives for discussion:
                                                </th>

                                                <th style={{ ...headerStyle, minWidth: 'auto', }}>
                                                    Comments:
                                                </th>

                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Action
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {anyAdditionalTopics.map((item, index) => (
                                                <tr>
                                                    <td style={{ ...cellStyleW, }}>{renderTextAreaFull(`any_additional_topics.${index}.title`, '', formik.values.any_additional_topics[index].title)}
                                                    </td>

                                                    <td style={{ ...cellStyleW, }}>{renderTextAreaFull(`any_additional_topics.${index}.comments`, '', formik.values.any_additional_topics[index].comments)}
                                                    </td>

                                                    <td style={cellStylea}>
                                                        {anyAdditionalTopics.length != 1 ? (<FaTrash onClick={() => handleDeleteInputForAnyAdditionalTopics(index)} className='delete-buttonXX' />) : null}

                                                        {anyAdditionalTopics.length - 1 == index ? (<FaPlus onClick={() => handleAddInputForAnyAdditionalTopics()} className='add-buttonXX' />) : null}
                                                    </td>

                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            {weeksList.map((we, weekIndex) => (
                                <AccordionTab
                                    header={
                                        <div className="flex justify-between items-center w-full accodianBtn" >

                                            <span className="font-bold white-space-nowrap ">WEEK #{weekIndex + 1}</span>

                                            <div className="flex items-center space-x-2">
                                                {weekIndex > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForWeeksList(weekIndex)} />) : null}

                                                {weeksList.length - 1 == weekIndex ? (<FaPlus className='add-buttonXX' onClick={() => handleAddForWeeksList()} />) : null}
                                            </div>
                                        </div>
                                    }
                                    className='mt-2 '>
                                    <div className="table-container form-bg" >
                                        <table style={{ borderCollapse: "collapse", }}>
                                            <thead>
                                                {/* <tr>
                                            <th style={{ ...headerStyleStart, minWidth: "300px" }} colSpan={6}>
                                                   
                                                </th>
                                                
                                            </tr> */}
                                                <tr>
                                                    <th style={{ ...headerStyle, minWidth: "300px" }}>
                                                        {renderInputAreaY(`weeks.${weekIndex}.finacial_point`, '0', 'text', formik.values.weeks[weekIndex].finacial_point)}
                                                    </th>
                                                    <th style={{ ...headerStyle, minWidth: "100px" }} >
                                                        POINTS
                                                    </th>
                                                    <th style={{ ...headerStyle, minWidth: "100px" }} >
                                                        SUPERVISOR POINTS
                                                    </th>

                                                    <th style={{ ...headerStyle, minWidth: "300px" }} >
                                                        FINANCIAL CONTROLER COMMENTS
                                                    </th>
                                                    <th style={{ ...headerStyle, minWidth: "300px" }} >
                                                        VP CONSTRUCTION OPERATIONS COMMENTS
                                                    </th>
                                                    <th style={{ ...headerStyle, width: "100px" }}>
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formik.values.weeks[weekIndex].week.map((item, index) => (

                                                    <tr>
                                                        <td style={cellStyleW} > {renderTextArea(`weeks.${weekIndex}.week.${index}.title`, '', formik.values.weeks[weekIndex].week[index].title)}</td>
                                                        <td style={cellStyleW} > {renderInputArea(`weeks.${weekIndex}.week.${index}.point_1`, '0', 'text', formik.values.weeks[weekIndex].week[index].point_1)}</td>
                                                        <td style={cellStyleW} > {renderInputArea(`weeks.${weekIndex}.week.${index}.point_2`, '0', 'text', formik.values.weeks[weekIndex].week[index].point_2)}</td>
                                                        <td style={cellStyleW} > {renderTextArea(`weeks.${weekIndex}.week.${index}.comments`, '', formik.values.weeks[weekIndex].week[index].comments)}</td>
                                                        <td style={cellStyleW} > {renderTextArea(`weeks.${weekIndex}.week.${index}.vp_comments`, '', formik.values.weeks[weekIndex].week[index].vp_comments)}</td>

                                                        <td style={cellStylea}>
                                                            {formik.values.weeks[weekIndex].week.length != 1 ? (<FaTrash onClick={() => handleDeleteInputForWeek(index, weekIndex)} className='delete-buttonXX' />) : null}

                                                            {formik.values.weeks[weekIndex].week.length - 1 == index ? (<FaPlus onClick={() => handleAddInputForWeek(weekIndex)} className='add-buttonXX' />) : null}
                                                        </td>

                                                    </tr>
                                                ))}

                                                <tr>
                                                    <td style={{ ...cellStyle, fontWeight: 'bold' }}>***NOTE:  If something is missing for a project but done on others, divide number of projects into the points number for the number of points***</td>

                                                    <td style={{ ...cellStyle, backgroundColor: "#B7B7B7" }}>{totalClientEmailWeek('point_1', weekIndex)}</td>
                                                    <td style={{ ...cellStyle, backgroundColor: "#B7B7B7" }}>{totalClientEmailWeek('point_2', weekIndex)}</td>

                                                    <td style={{ ...cellStyle, }}></td>
                                                    <td style={{ ...cellStyle, }}></td>
                                                    <td style={{ ...cellStyle, }}></td>
                                                </tr>

                                                <tr>

                                                    <th style={{ ...headerStyle, minWidth: "auto" }} >

                                                        <textarea
                                                            type="text"
                                                            value={totalPointMeetingJob}
                                                            onChange={(e) => {
                                                                setTotalPointMeetingJob(e.target.value)
                                                            }}

                                                            style={{ ...headerStyle, border: 'none', outline: 'none', textAlign: 'start', width: '100%', height: '40px', boxSizing: 'border-box', fontWeight: 'bold', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
                                                        />
                                                    </th>

                                                    <td style={cellStyle}>
                                                        {cilentPlayBookTotalPerColor('point_1', weekIndex, formik.values.weeks[weekIndex].finacial_point)}
                                                    </td>
                                                    <td style={cellStyle}>
                                                        {cilentPlayBookTotalPerColor('point_2', weekIndex, formik.values.weeks[weekIndex].finacial_point)}
                                                    </td>

                                                    <th style={{ ...headerStyle, minWidth: "auto" }} colSpan={3} >

                                                        <textarea
                                                            type="text"
                                                            value={pointsMeetingJob}
                                                            onChange={(e) => {
                                                                setPointsMeetingJob(e.target.value)
                                                            }}

                                                            style={{ ...headerStyle, border: 'none', outline: 'none', textAlign: 'start', width: '100%', height: '40px', boxSizing: 'border-box', fontSize: '16px', fontWeight: 'bold', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
                                                        />
                                                    </th>


                                                </tr>
                                                <tr>
                                                    <td style={{ padding: '10px' }} colSpan={12} >
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }} >
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <div style={{
                                                                    width: '15px',
                                                                    height: '15px',
                                                                    backgroundColor: '#22a33d',
                                                                    borderRadius: '50%',
                                                                    marginRight: '5px'
                                                                }}></div>
                                                                <strong>90% - 100% full bonus</strong>
                                                            </div>

                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <div style={{
                                                                    width: '15px',
                                                                    height: '15px',
                                                                    backgroundColor: '#FFBF00',
                                                                    borderRadius: '50%',
                                                                    marginRight: '5px'
                                                                }}></div>
                                                                <strong>80% - 89.9% is 80% of bonus</strong>
                                                            </div>

                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <div style={{
                                                                    width: '15px',
                                                                    height: '15px',
                                                                    backgroundColor: 'red',
                                                                    borderRadius: '50%',
                                                                    marginRight: '5px'
                                                                }}></div>
                                                                <strong>70% - 79.9 is 79% of bonus</strong>
                                                            </div>

                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <div style={{
                                                                    width: '15px',
                                                                    height: '15px',
                                                                    backgroundColor: 'red',
                                                                    borderRadius: '50%',
                                                                    marginRight: '5px'
                                                                }}></div>
                                                                <strong>Below 70% is no bonus</strong>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td style={{ ...cellStyle, minHeight: "100px" }} colSpan={11}></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </AccordionTab>
                            ))}



                            <AccordionTab header="DISCUSSION ITEMS" className='mt-2 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>

                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: '300px', textAlign: 'start' }}>
                                                    Discussion Items:
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Action
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {discussionItem.map((item, index) => (
                                                <tr>
                                                    <td style={{ ...cellStyleW, }}>{renderTextAreaFull(`discussion_item.${index}.discussion_items`, '', formik.values.discussion_item[index].discussion_items)}
                                                    </td>
                                                    <td style={cellStylea}>
                                                        {discussionItem.length != 1 ? (<FaTrash onClick={() => handleDeleteInputForDiscussionItem(index)} className='delete-buttonXX' />) : null}

                                                        {discussionItem.length - 1 == index ? (<FaPlus onClick={() => handleAddInputForDiscussionItem()} className='add-buttonXX' />) : null}
                                                    </td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="GOALS FOR THE WEEK" className='mt-2 mb-4 '>
                                <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, textAlign: 'start' }} >
                                                    Goals For the Week
                                                </th>
                                                <th style={{ ...headerStyle, textAlign: 'start' }} >
                                                    Done
                                                </th>
                                                <th style={{ ...headerStyle, }} colSpan={2} >

                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Actions
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {goalForTheWeek.map((item, key) => (
                                                <>


                                                    <tr>

                                                        <td style={{ ...cellStyleW, width: "300px" }} rowSpan={2}>{renderTextAreaFull(`goals_for_the_week.${key}.title`, '', formik.values.goals_for_the_week[key].title)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: '85px', height: '32px', }}>{renderSelect1(`goals_for_the_week.${key}.reason_1`, formik.values.goals_for_the_week[key].reason_1)} </td>
                                                        <td style={{ ...headerStyle, width: '185px', }}>Last Week </td>
                                                        <td style={{ ...cellStyleW, minWidth: "auto" }}>{renderTextAreaFull(`goals_for_the_week.${key}.comments_1`, '', formik.values.goals_for_the_week[key].comments_1)} </td>


                                                        <td style={cellStylea} rowSpan={2}>

                                                            {goalForTheWeek.length != 1 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForGoalForTheWeek(key)} />) : null}

                                                            {goalForTheWeek.length - 1 == key ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForGoalForTheWeek()} />) : null}


                                                        </td>

                                                    </tr>
                                                    <tr >

                                                        <td style={{ ...dropdownCellStyle, width: '85px', height: '32px', }}>{renderSelect1(`goals_for_the_week.${key}.reason_2`, formik.values.goals_for_the_week[key].reason_2)} </td>
                                                        <td style={{ ...headerStyle, width: '85px', }}>This Week </td>

                                                        <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`goals_for_the_week.${key}.comments_2`, '', formik.values.goals_for_the_week[key].comments_2)} </td>

                                                    </tr>

                                                </>


                                            ))}

                                        </tbody>
                                    </table>

                                    <table style={{ borderCollapse: "collapse", marginTop: "20px" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, }} colSpan={2}>                                                    
                                                    To Discuss (i.e. Customer Issues, Crew Issues, Customer Closing, Etc.)
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Action
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {toDiscuss.map((item, key) => (
                                                <tr key={key}>


                                                    <td style={{ ...cellStyleW, width: '300px' }}>{renderTextAreaFull(`to_discuss.${key}.title`, '', formik.values.to_discuss[key].title)} </td>
                                                    <td style={{ ...cellStyleW, minWidth: "600px" }}>{renderTextAreaFull(`to_discuss.${key}.comments`, '', formik.values.to_discuss[key].comments)} </td>

                                                    <td style={cellStylea}>

                                                        {toDiscuss.length != 1 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputFortoDiscuss(key)} />) : null}

                                                        {toDiscuss.length - 1 == key ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputFortoDiscuss()} />) : null}

                                                    </td>

                                                </tr>
                                            ))}



                                        </tbody>
                                    </table>
                                </div>

                            </AccordionTab>





                        </Accordion>

                    )}

                </div>
            </form>



        </>
    )
}

export default FinancialController

